import { sendPasswordResetEmail } from "firebase/auth"

import { auth, actionCodeSettings } from "./auth"

export const resetPassword = (email: string) => {
  return sendPasswordResetEmail(auth, email, actionCodeSettings)
}
